import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ParLanguageCommunication from './par-language-communication';
import ParLanguageCommunicationDetail from './par-language-communication-detail';
import ParLanguageCommunicationUpdate from './par-language-communication-update';
import ParLanguageCommunicationDeleteDialog from './par-language-communication-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ParLanguageCommunicationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ParLanguageCommunicationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ParLanguageCommunicationDetail} />
      <ErrorBoundaryRoute path={match.url} component={ParLanguageCommunication} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ParLanguageCommunicationDeleteDialog} />
  </>
);

export default Routes;
